import { makeAutoObservable, runInAction } from 'mobx';
import {
  ITermsAndCondition,
  ITermsAndConditionParams,
} from 'src/@types/Choqorak/Settings/TermsAndCondition';
import agent from 'src/api/agent';
export default class TermsAndConditionStore {
  openDialog = false;

  TermsAndConditionRegistry = new Map<number, ITermsAndCondition>();

  editMode = false; //When click on edit button

  selectedTermsAndCondition: ITermsAndCondition | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get TermsAndConditionList() {
    return Array.from(this.TermsAndConditionRegistry.values());
  }

  setTermsAndConditionList = (TermsAndCondition: ITermsAndCondition) => {
    this.TermsAndConditionRegistry.set(TermsAndCondition.termAndConditionId!, TermsAndCondition);
  };

  //Pagination
  loadTermsAndCondition = async (params: ITermsAndConditionParams) => {
    // this.TermsAndConditionRegistry.clear();
    try {
      const result = await agent.TermsAndCondition.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setTermsAndConditionList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  TermsAndConditionSearch = async (params: ITermsAndConditionParams) => {
    this.TermsAndConditionRegistry.clear();
    this.loadTermsAndCondition(params);
  };

  getTermsAndConditionFromRegistry = (id: number) => {
    let TermsAndCondition = this.TermsAndConditionRegistry.get(id);
    if (TermsAndCondition) {
      this.editMode = true;
      this.selectedTermsAndCondition = TermsAndCondition;
    }
  };

  clearSelectedTermsAndCondition = () => {
    this.editMode = false;
    this.selectedTermsAndCondition = undefined;
  };

  deleteTermsAndCondition = async (id: number, remark?: string) => {
    try {
      await agent.TermsAndCondition.delete(id, remark!);
      runInAction(() => {
        this.TermsAndConditionRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createTermsAndCondition = async (TermsAndCondition: ITermsAndCondition) => {

      await agent.TermsAndCondition.create(TermsAndCondition);
      runInAction(() => {
        this.loadTermsAndCondition({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedTermsAndCondition();
      });
    
  };

  updateTermsAndCondition = async (TermsAndCondition: ITermsAndCondition) => {
  
      await agent.TermsAndCondition.update(TermsAndCondition);

      runInAction(() => {
        this.loadTermsAndCondition({ pageIndex: 0, pageSize: 5 });
        this.TermsAndConditionRegistry.delete(TermsAndCondition.termAndConditionId!);
        this.TermsAndConditionRegistry.set(
          TermsAndCondition.termAndConditionId!,
          TermsAndCondition
        );
        this.clearSelectedTermsAndCondition();
      });
  
  };
}
